/* unplugin-vue-components disabled */import script from "./TagPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TagPanel.vue?vue&type=style&index=0&id=1c945ad0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c945ad0"]])

export default __exports__